import { Box, chakra } from "@chakra-ui/react";

interface SettingToggleProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  ariaLabel: string;
}

/**
 * The on/off switch used by the settings pages (notification categories,
 * Friends Only). Rendered as role="switch" rather than a native checkbox so
 * the knob/track animation is ours, while assistive tech and Playwright still
 * see a labelled, checkable control.
 */
export function SettingToggle({
  checked,
  onChange,
  disabled,
  ariaLabel,
}: SettingToggleProps) {
  return (
    <chakra.button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      onClick={() => !disabled && onChange()}
      disabled={disabled}
      position="relative"
      w="44px"
      h="26px"
      borderRadius="pill"
      bg={checked ? "bg.brand" : "#D6D9DD"}
      border="0"
      cursor={disabled ? "not-allowed" : "pointer"}
      transition="background 150ms ease"
      flexShrink={0}
      opacity={disabled ? 0.55 : 1}
      _hover={!disabled ? { filter: "brightness(1.04)" } : undefined}
    >
      <Box
        position="absolute"
        top="3px"
        left={checked ? "21px" : "3px"}
        w="20px"
        h="20px"
        borderRadius="full"
        bg="white"
        boxShadow="0 1px 3px rgba(0,0,0,0.25)"
        transition="left 150ms ease"
      />
    </chakra.button>
  );
}
